import { render, staticRenderFns } from "./Quickstart.vue?vue&type=template&id=1dc47759&scoped=true&"
import script from "./Quickstart.vue?vue&type=script&lang=js&"
export * from "./Quickstart.vue?vue&type=script&lang=js&"
import style0 from "./Quickstart.vue?vue&type=style&index=0&id=1dc47759&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc47759",
  null
  
)

export default component.exports